import './index.scss';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '~/providers/auth';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
const Landing = () => {
    const { stateId } = useParams();
    const { isAuthenticated, loginState, deleteLoginState } = useAuth();
    const { hasUserInfo, hasPermission, permissions } = useUser();
    const landingLoading = (text) => {
        return (React.createElement("div", { className: 'landing-container' },
            React.createElement("div", { className: 'landing-overlay' }),
            React.createElement("div", { className: 'loading-container' },
                React.createElement(LoadingElement, { isLightBackground: true }),
                React.createElement("h3", null, text))));
    };
    if (!isAuthenticated) {
        return landingLoading('Authenticating...');
    }
    if (!hasUserInfo) {
        return landingLoading('Loading user configuration...');
    }
    if (hasPermission(Permissions.INITIAL_DEFAULT_LIMITED_ACCESS) ||
        permissions.length === 0) {
        return React.createElement("div", { className: 'missing-role-container' },
            React.createElement("h3", null, "Missing User Role"),
            React.createElement("p", null, "Your profile appears to be missing a user role. Please reach out to customer support to be assigned one."));
    }
    if (loginState && stateId && loginState[stateId]) {
        const from = loginState[stateId];
        let toRoute = from.pathname.includes('/login') ? '/' : from.pathname;
        if (from.search) {
            toRoute += `${from.search}`;
        }
        deleteLoginState();
        return React.createElement(Navigate, { to: toRoute });
    }
    return React.createElement(Navigate, { to: '/' });
};
export default Landing;
